import React from "react";

import {CircularProgress, Stack} from "@mui/joy";
import Input from "@mui/joy/Input";
import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import FormLabel from "@mui/joy/FormLabel";


export class CommonJSONField extends React.Component {
    render() {
        return(
            <Stack
                sx={{
                    width: '100%'
                }}
            >
                <FormLabel>{this.props.label}</FormLabel>
                <textarea
                    defaultValue={JSON.stringify(this.props.defaultValue,null, 4)}
                    name={this.props.name}
                    rows={this.props.rows?this.props.rows:10}
                    cols={50}
                    onKeyDown={(event) => {
                            if (event.key === 'Tab'){
                                event.preventDefault();
                                const start = event.target.selectionStart;
                                const end = event.target.selectionEnd;
                                event.target.value = event.target.value.substring(0, start) + '    ' + event.target.value.substring(end);
                                event.target.selectionStart = start + 4;
                                event.target.selectionEnd = start + 4;
                            }
                        }
                    }
                    disabled={this.props.disabled}
                />
            </Stack>
        )
    }
}


class CommonJSONFieldForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            objectValues: null,
        };
    }

    componentDidMount() {
        let objectValues = {}
        for (let k of Object.keys(this.props.value)){
            if (typeof this.props.value[k] === 'object'){
                objectValues[k] = this.props.value[k]
            }
        }
        this.setState({
            objectValues: objectValues,
        })
    }

    async onSubmit(event){
        event.preventDefault();
        let formDataObj = Object.fromEntries(
            (new FormData(event.currentTarget)).entries()
        );
        for (let k of Object.keys(formDataObj)){
            switch (typeof this.props.value[k]) {
                case "number":
                    formDataObj[k] = parseInt(formDataObj[k])
                    break
                case "boolean":
                    formDataObj[k] = !!formDataObj[k]
                    break
                default:
                    break
            }
            if (Object.keys(this.state.objectValues).includes(k)){
                formDataObj[k] = JSON.parse(formDataObj[k])
            }
        }
        await this.props.processForm(formDataObj);
    }

    render() {
        if (!this.state.objectValues) {
            return (<CircularProgress/>)
        }
        return(
            <form
                onSubmit={this.onSubmit.bind(this)}
                style={{
                    width: '100%',
                }}
            >
                <Stack
                    spacing={1}
                >
                    {
                        Object.entries(this.props.value).map(
                            (kv, index) => (
                                <Stack
                                    direction={'row'}
                                    spacing={2}
                                >

                                    <Typography>
                                        {kv[0]}
                                    </Typography>
                                    {
                                        Object.keys(this.state.objectValues).includes(kv[0])?
                                            <CommonJSONField
                                                defaultValue={this.state.objectValues[kv[0]]}
                                                name={kv[0]}
                                            />
                                            :
                                            <Input
                                                type={
                                                    (() => {
                                                        switch (typeof kv[1]) {
                                                            case "string":
                                                                return 'text'
                                                            case "number":
                                                                return 'number'
                                                            case "boolean":
                                                                return 'checkbox'
                                                            default:
                                                                return 'text'
                                                        }
                                                    })()
                                                }
                                                id={kv[0]}
                                                name={kv[0]}
                                                defaultValue={kv[1]}
                                            />
                                    }
                                </Stack>
                            )
                        )
                    }
                </Stack>
                <Button
                    sx={{
                        mt: 2
                    }}
                    type={'submit'}
                    color={'primary'}
                >
                    Сохранить
                </Button>
            </form>
        )
    }
}

export default CommonJSONFieldForm
